import { numericFormat } from '@utils/index';
import { FC } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import styles from './index.module.scss';

interface OwnProps {
  summary: OpenapiClientParrotVault.GetVaultStatsSummaryResponse | undefined;
}

const EarnTvNumber: FC<OwnProps> = ({ summary }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.chart_text1}>${numericFormat(summary?.revenue_24h_usd || 0)}</div>
        <div className={styles.chart_text2}>Daily Revenue</div>
      </div>
      <div>
        <div className={styles.chart_text1}>{summary?.wallet_count || 0}</div>
        <div className={styles.chart_text2}>Total Accounts</div>
      </div>
    </div>
  );
};

export default EarnTvNumber;
